/**
 * HeaderList.js
 */

import React from 'react';
import styled from 'styled-components';
import HeaderItem from './HeaderItem';
import {labels} from '../../../../util/utils';

export default function HeaderList(props) {
	const {headers, formData, engagementId, documentId, isSnapshotView, changesView} = props;

	return (
		<Wrapper className="StyledHeaderList SelectedCanvasFormBody customScrollbar">
			{headers && headers.length > 0 ? (
				headers.map((header) => {
					return (
						header.sections?.filter((s) => s.isDisplayed === true || s.isCustom === true).length > 0 && (
							<HeaderItem
								formData={formData}
								key={header.id}
								header={header}
								engagementId={engagementId}
								documentId={documentId}
								isSnapshotView={isSnapshotView}
								changesView={changesView}
							/>
						)
					);
				})
			) : (
				<section className="emptyContainer">{labels.noContentAvailable}</section>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	padding: 0;
	overflow-y: auto;
	position: relative;
`;
